module.exports = __webpack_public_path__ + "static/img/renyuankaohe.298f3680.png";